import { c as _c } from "react/compiler-runtime";
import { AzResultPoster } from 'src/components/search/ResultPoster';
import type { WatchableContent } from 'src/lib/movieinfo/movieinfotypes';
import { isFilmwebSearchDocument, type ISearchResult } from "src/lib/types/search";
//#region [Styles]

//#endregion

//#region [Props]
type SearchContentItemProps = {
  content: WatchableContent | ISearchResult;
  forceStreaming?: boolean;
  className?: string;
  clickTracker?: (id: string | number, title: string) => void;
  azShowScore?: boolean;
  forceHardlinks?: boolean;
};
//#endregion

//#region [Component]
export default function SearchContentItem(t0) {
  const $ = _c(8);
  const {
    content,
    className,
    clickTracker,
    forceStreaming: t1,
    azShowScore: t2,
    forceHardlinks: t3
  } = t0;
  const forceStreaming = t1 === undefined ? false : t1;
  const azShowScore = t2 === undefined ? false : t2;
  const forceHardlinks = t3 === undefined ? false : t3;
  const item = content as ISearchResult;
  const key = isFilmwebSearchDocument(item.document) ? item.document.edi ?? item.document.streamingId : item.document.foMId;
  const t4 = content as ISearchResult;
  let t5;
  if ($[0] !== azShowScore || $[1] !== className || $[2] !== clickTracker || $[3] !== forceHardlinks || $[4] !== forceStreaming || $[5] !== key || $[6] !== t4) {
    t5 = <AzResultPoster key={key} forceStreaming={forceStreaming} className={className} data={t4} clickTracker={clickTracker} showScore={azShowScore} forceHardlinks={forceHardlinks} />;
    $[0] = azShowScore;
    $[1] = className;
    $[2] = clickTracker;
    $[3] = forceHardlinks;
    $[4] = forceStreaming;
    $[5] = key;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
//#endregion